import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { matchingAnalyticsReducer } from './matching-analytics.reducer';
import { MatchingAnalyticsEffects } from './matching-analytics.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('matchingAnalytics', matchingAnalyticsReducer),
    EffectsModule.forFeature([MatchingAnalyticsEffects])
  ]
})
export class MatchingAnalyticsStateModule {}
